<div class="block">
  <div class="flex justify-space-between align-center">
    <div> Ship to </div>
    <div>
      <button
        *ngIf="!toggleRecipientForm"
        mat-button
        (click)="onToggleEditRecipient()"
        class="lum-button lum-button--tertiary link"
      >
        Edit
      </button>
    </div>
  </div>
  <div>
    <div class="form-field" *ngIf="!toggleRecipientForm">
      <div class="text-large">
        {{ data.name }}
      </div>
      <div class="text-large">
        {{ data.company }}
      </div>
      <div class="text-large">
        {{ data.street1 }}
      </div>
      <div *ngIf="data.street2" class="text-large">
        {{ data.street2 }}
      </div>
      <div *ngIf="data.street3" class="text-large">
        {{ data.street3 }}
      </div>
      <div class="text-large">
        {{ data.city }}, {{ data.state }} {{ data.postalCode }} {{ data.country }}
      </div>
      <div class="text-large">
        {{ data.phone }}
      </div>
      <div [ngClass]="addressValidationColor + ' py-2 flex gap-2 align-center'">
        <i [ngClass]="addressValidationIcon + ' icon-address-medium'"></i>
        <div>
          {{ data.addressVerified }}
        </div>
      </div>
    </div>
    <div *ngIf="toggleRecipientForm" class="modal__wrapper">
      <form
        [formGroup]="form"
        class="form__wrapper flex gap-4 grow"
        (submit)="onSubmit()"
      >
        <div class="form-field">
          <div> Name </div>
          <div>
            <input
              formControlName="name"
              type="string"
              required="true"
              matInput
              class="lum-input"
              [ngClass]="{
                error: form.get('name')?.invalid,
              }"
            />
            <mat-error *ngIf="nameControl && nameControl.invalid">
              {{ nameControl | validateField }}
            </mat-error>
          </div>
        </div>
        <div class="form-field">
          <div> Company </div>
          <div>
            <input
              formControlName="company"
              type="string"
              matInput
              class="lum-input"
            />
            <mat-error *ngIf="companyControl && companyControl.invalid">
              {{ companyControl | validateField }}
            </mat-error>
          </div>
        </div>
        <div class="form-field">
          <div> Country </div>
          <div>
            <mat-select
              formControlName="country"
              class="lum-select"
              required="true"
              [ngClass]="{
                error: form.get('country')?.invalid,
              }"
            >
              <mat-option
                *ngFor="let country of countries; trackBy: trackById"
                [value]="country.id"
              >
                {{ country.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="countryControl && countryControl.invalid">{{
              countryControl | validateField
            }}</mat-error>
          </div>
        </div>
        <div class="form-field">
          <div> Address </div>
          <div>
            <input
              formControlName="street1"
              type="string"
              required="true"
              matInput
              class="lum-input"
              [ngClass]="{
                error: form.get('street1')?.invalid,
              }"
            />
            <mat-error *ngIf="street1Control && street1Control.invalid">
              {{ street1Control | validateField }}
            </mat-error>
          </div>
          <div>
            <input
              formControlName="street2"
              type="string"
              matInput
              class="lum-input"
              [ngClass]="{
                error: form.get('street1')?.invalid,
              }"
            />
          </div>
          <div>
            <input
              formControlName="street3"
              type="string"
              matInput
              class="lum-input"
              [ngClass]="{
                error: form.get('street1')?.invalid,
              }"
            />
          </div>
        </div>
        <div class="flex gap-2">
          <div class="form-field">
            <div> City </div>
            <div>
              <input
                formControlName="city"
                type="string"
                required="true"
                matInput
                class="lum-input"
                [ngClass]="{
                  error: form.get('city')?.invalid,
                }"
              />
              <mat-error *ngIf="cityControl && cityControl.invalid">
                {{ cityControl | validateField }}
              </mat-error>
            </div>
          </div>
          <div class="form-field w-20">
            <div> State </div>
            <div>
              <mat-select
                formControlName="state"
                class="lum-select"
                required="true"
                [ngClass]="{
                  error: form.get('state')?.invalid,
                }"
              >
                <mat-option
                  *ngFor="let state of states; trackBy: trackById"
                  [value]="state.id"
                >
                  {{ state.id }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="stateControl && stateControl.invalid">{{
                stateControl | validateField
              }}</mat-error>
            </div>
          </div>
          <div class="form-field">
            <div> Zip Code </div>
            <div>
              <input
                formControlName="postalCode"
                type="string"
                required="true"
                matInput
                class="lum-input"
                [ngClass]="{
                  error: form.get('postalCode')?.invalid,
                }"
              />
              <mat-error *ngIf="postalCodeControl && postalCodeControl.invalid">
                {{ postalCodeControl | validateField }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="form-field">
          <div> Phone </div>
          <div>
            <input
              formControlName="phone"
              type="string"
              matInput
              class="lum-input"
            />
            <mat-error *ngIf="phoneControl && phoneControl.invalid">
              {{ phoneControl | validateField }}
            </mat-error>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="toggleRecipientForm" class="flex gap-4 justify-end pt-4">
    <button
      mat-button
      [disabled]="loading"
      (click)="onToggleEditRecipient()"
      class="lum-button lum-button--secondary"
    >
      Cancel
    </button>
    <button
      mat-button
      [disabled]="loading || form.invalid"
      (click)="onSubmit()"
      class="lum-button lum-button--primary"
    >
      <ng-container *ngIf="!loading; else loader"> Save </ng-container>
      <ng-template #loader>
        <mat-progress-spinner
          class="progress-spinner"
          diameter="13"
          mode="indeterminate"
        ></mat-progress-spinner>
      </ng-template>
    </button>
  </div>
</div>
